import { createContext } from "react";

type AuthUser = {
  username?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  roles?: string[];
  [key: string]: unknown;
};

type GlobalContextType = {
  state: {
    auth: {
      token: string | null;
      refreshToken: string | null;
      user: AuthUser | null;
    };
    cartCount: number;
  };
  dispatch: (action: unknown) => void;
  login: (token: string, user: AuthUser, refreshToken?: string) => void;
  logout: () => void;
  setCartCount: (count: number) => void;
};

const storedUser = localStorage.getItem("user");

const values: GlobalContextType = {
  state: {
    auth: {
      token: localStorage.getItem("token"),
      refreshToken: localStorage.getItem("refreshToken"),
      user: storedUser ? JSON.parse(storedUser) : null,
    },
    cartCount: Number(localStorage.getItem('cartCount') || 0),
  },
  dispatch: () => {},
  login: () => {},
  logout: () => {},
  setCartCount: () => {},
};
export const GlobalContext = createContext(values);
GlobalContext.displayName = "GlobalContext";
